/**
 * Vertical Steps Widget - Intersection Observer Animation
 * Changes .step-jaartal background color when scrolled to 50% viewport
 */
( function() {
    'use strict';

    function initStepsVertical() {
        const stepsContainers = document.querySelectorAll( '.vertical-steps' );
        if ( ! stepsContainers.length ) {
            return;
        }

        // Observer for .text items (animate on intersection)
        const observer = new IntersectionObserver( ( entries ) => {
            entries.forEach( ( entry ) => {
                if ( entry.isIntersecting ) {
                    entry.target.classList.add( 'animate' );
                } else {
                    entry.target.classList.remove( 'animate' );
                }
            } );
        }, {
            threshold: 0.5,
        } );

        // Observer for .step-jaartal elements (color change when at 50% of window height)
        const observedJaartals = new Set();
        const visibleJaartals = new Set();

        const jaartalObserver = new IntersectionObserver( ( entries ) => {
            entries.forEach( ( entry ) => {
                // Skip first intersection on page load
                if ( ! observedJaartals.has( entry.target ) ) {
                    observedJaartals.add( entry.target );
                    return;
                }

                // Add class only once when element reaches 50% of window height
                if ( entry.isIntersecting && ! visibleJaartals.has( entry.target ) ) {
                    entry.target.classList.add( 'is-visible' );
                    visibleJaartals.add( entry.target );
                }
            } );
        }, {
            rootMargin: '-50% 0px -50% 0px',
            threshold: 0,
        } );

        stepsContainers.forEach( ( container ) => {
            // Observe .text items for animation
            container.querySelectorAll( '.text' ).forEach( ( item ) => {
                observer.observe( item );
            } );

            // Observe .step-jaartal items for color change
            container.querySelectorAll( '.step-jaartal' ).forEach( ( jaartal ) => {
                jaartalObserver.observe( jaartal );
            } );
        } );
    }
    // Initialize on DOM ready
    if ( document.readyState === 'loading' ) {
        document.addEventListener( 'DOMContentLoaded', initStepsVertical );
    } else {
        initStepsVertical();
    }
    
    // Reinitialize on responsive resize
    window.addEventListener('responsiveResize', initStepsVertical);
    
    // Re-initialize on Elementor live edit
    if ( window.elementorFrontend ) {
        window.elementorFrontend.hooks.addAction(
            'frontend/element_ready/db_steps-vertical.default',
            initStepsVertical
        );
    }
} )();